import { render, staticRenderFns } from "./MenuSwiperWeb.vue?vue&type=template&id=d72b5814&scoped=true&"
import script from "./MenuSwiperWeb.vue?vue&type=script&lang=js&"
export * from "./MenuSwiperWeb.vue?vue&type=script&lang=js&"
import style0 from "./MenuSwiperWeb.vue?vue&type=style&index=0&id=d72b5814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72b5814",
  null
  
)

export default component.exports